module.exports = __webpack_public_path__ + "static/media/mission-realworld-ic.97e42381.svg";